import { installMaterialIcons } from '@org/primitives/material-icons';
import { prepareStartupDocument } from '@org/state/startup';

{
  installMaterialIcons(document);
  const startup = prepareStartupDocument();
  const bootstrapModule = import('./bootstrap');
  Promise.all([startup.stylesReady, bootstrapModule])
    .then(([, { bootstrap }]) => bootstrap())
    .then(() => startup.complete())
    .catch((err) => {
      startup.fail();
      console.error(err);
    });
}
